// First API Layer of riskAccumulation actions
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import {
  RISKACCUMULATION_LOADING,
  RISKACCUMULATION_SUCCESS,
  RISKACCUMULATION_FAIL,
  RISKACCUMULATIONLIST_SUCCESS,
  RISKACCUMULATIONLIST_LOADING,
  RISKACCUMULATIONLIST_FAIL
} from '@/store/types'

export const general = {
  async riskAccumulationInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.riskAccumulation
    commit(RISKACCUMULATION_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(RISKACCUMULATION_SUCCESS, commitResult)
      } catch (error) {
        commit(RISKACCUMULATION_FAIL, extractMessages(error))
      }
    } else {
      commit(RISKACCUMULATION_FAIL, extractMessages(['The request failed because it is trying to execute an invalid API url. [riskAccumulationInit]']))
    }
  },
  async riskAccumulationListInit({ commit, state }) {
    const apiUrl = state.menu.riskAccumListing
    if (apiUrl) {
      commit(RISKACCUMULATIONLIST_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(RISKACCUMULATIONLIST_SUCCESS, commitResult)
      } catch (error) {
        commit(RISKACCUMULATIONLIST_FAIL, extractMessages(error))
      }
    } else {
      commit(RISKACCUMULATIONLIST_FAIL, extractMessages(['The request failed because it is trying to execute an invalid API url. [riskAccumulationListInit]']))
    }
  }
}
